import { blocks, site, view } from '@yola/ws-sdk';
import getParentBlockByElement from 'src/js/modules/blocks/helpers/get-parent-block-by-element';
import getTemplateBuildSlugTrait from 'src/js/modules/analytics/segment/helpers/get-template-build-slug-trait';

const getDefaultTraits = (elementId) => {
  const element = view.accessors.getLiveElement(elementId);
  const blockElement = getParentBlockByElement(element);

  return {
    siteId: site.accessors.getSiteId(),
    templateBuildSlug: getTemplateBuildSlugTrait(),
    blockId: blocks.accessors.getBlockIdByElement(blockElement),
    blockVariationId: blocks.accessors.getVariationIdByElement(blockElement),
  };
};

export default getDefaultTraits;
